import type { SortedBTGs } from '~/sidebar/sidebarApps/mapTools/boundary/boundaryTools.types';
import { useBoundaryItems } from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useBoundaryItems';
import { useBoundaryTerritoryGroupDisplayName } from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useBoundaryTerritoryGroupDisplayName';
import { useBTGFillData } from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useBTGFillData';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { BoundaryTerritoryGroupKeyComponent } from './boundaryTerritoryGroupKey.component';

export const BoundaryTerritoryGroupKeyContainer = ({
  boundaryGroupId,
  boundaryTerritoryGroups,
  isExpanded,
  onToggle,
}: {
  boundaryGroupId: BoundaryGroupId;
  boundaryTerritoryGroups: SortedBTGs;
  isExpanded: boolean;
  onToggle: () => void;
}) => {
  const { getBoundaryTerritoryGroupName } = useBoundaryTerritoryGroupDisplayName();

  const {
    activeBTGOption,
    activeBoundaryTerritoryGroup,
  } = useBTGFillData({
    boundaryGroupId,
    boundaryTerritoryGroups,
  });

  const boundaryItems = useBoundaryItems({ boundaryTerritoryGroup: activeBoundaryTerritoryGroup });

  const { shortenedSubEntity, mainEntity } = activeBTGOption?.entities || {};

  const boundaryTerritoryGroupName = getBoundaryTerritoryGroupName(activeBoundaryTerritoryGroup);

  return (
    <BoundaryTerritoryGroupKeyComponent
      activeBoundaryTerritoryGroup={activeBoundaryTerritoryGroup}
      boundaryTerritoryGroupName={boundaryTerritoryGroupName}
      boundaryItemsProps={boundaryItems}
      isExpanded={isExpanded}
      mainEntity={mainEntity}
      shortenedSubEntity={shortenedSubEntity}
      onToggle={onToggle}
    />
  );
};
